<template>
  <div class="wrapper">
    <header class="py-3">
      <h2 class="mb-0 text-white text-center">{{ title }}</h2>
    </header>

    <div class="container py-4">
      <div class="row mb-5 align-items-center">
        <div class="col-sm-5">
          <div class="animated-card mb-3" :class="{ 'slide-in': isAnimated }">
            <div class="text-center">
              <img
                :src="selectedVaccine?.imgPath || defaultImg"
                :alt="selectedVaccine?.name || 'Vaccine'"
                class="img-fluid mb-2"
              />
            </div>
          </div>

          <div class="animated-card" :class="{ 'slide-in': isAnimated }">
            <div class="text-center">
              <img
                :src="secondaryImage"
                alt="Secondary"
                class="img-fluid mb-2"
              />
            </div>
          </div>
        </div>

        <div class="col-sm-7">
          <div class="row g-3">
            <div
              v-for="(data, key) in selectedVaccine?.ModalData"
              :key="key"
              class="col-md-12 animated-card"
              role="button"
              :class="{ 'slide-in': isAnimated }"
              @click="openModal(key, data.text)"
            >
              <div class="text-center">
                <img :src="data.img" :alt="key" class="img-fluid mb-2" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-5 lower-panner">
        <img
          :src="footerBanner1"
          alt="Footer Banner 1"
          class="img-fluid mx-auto d-block"
        />
      </div>
      <div class="text-center mt-4 lower-panner">
        <img
          :src="footerBanner2"
          alt="Footer Banner 2"
          class="img-fluid mx-auto d-block"
        />
      </div>
    </div>

    <!-- <FooterNavigation :prevRoute="prevRoute" :nextRoute="nextRoute" /> -->
    <ReusableModal
      :isVisible="isModalVisible"
      :title="modalTitle"
      :text="modalText"
      @close="isModalVisible = false"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, defineProps } from "vue";
import { useRoute } from "vue-router";
// import FooterNavigation from "@/components/FooterNavigation.vue";
import ReusableModal from "@/components/ReusableModal.vue";

const props = defineProps({
  title: String,
  vaccines: Array,
  prevRoute: String,
  nextRoute: String,
  secondaryImage: String,
  footerBanner1: String,
  footerBanner2: String,
  defaultImg: String,
});

const route = useRoute();
const isAnimated = ref(false);
const isModalVisible = ref(false);
const modalTitle = ref("");
const modalText = ref("");

const selectedVaccine = computed(() =>
  props.vaccines.find((vaccine) => vaccine.name === route.params.name)
);

const openModal = (title, text) => {
  modalTitle.value = title;
  modalText.value = text;
  isModalVisible.value = true;
};



onMounted(() => {
  setTimeout(() => {
    isAnimated.value = true;
  }, 100);
});
</script>

<style scoped>
.wrapper {
  background-color: #f5f9fc;
  min-height: 100vh;
}

header {
  background-color: #2c4fa1;
}

.animated-card {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.6s ease;
}

.animated-card.slide-in {
  opacity: 1;
  transform: translateY(0);
}
</style>
